import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Form,
  Container,
  Row,
  Col,
  CardImg,
  Modal,
} from "reactstrap";
import { Route, useHistory, useLocation } from "react-router";
import Switch from "react-bootstrap/esm/Switch";
import ReactBSAlert from "react-bootstrap-sweetalert";
import "./styles.css";

import "../login.css";

import Parser from 'html-react-parser';
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';

// core components
import BlockUI from "components/Misc/BlockUI";
import AdminFooter from "components/Footers/MainFooter";
import { PasswordLabel } from "customComponents/customComponents";
import { CustomInputFields } from "customComponents/customComponents";
import { set } from "lodash";

const AcceptInvitaion = () => {
  // const { firmDetails } = useContext(MainContext)
  const [firmDetails, setFirmDetails] = useState();
  const routerLocation = useLocation();
  const routerHistory = useHistory();
  // eslint-disable-next-line
  const [user, setUser] = useState({});
  let [error, setError] = useState("");
  let [alert, setAlert] = useState(false);
  const [isInvalid, setIsInvalid] = useState(false);
  const [showBlockUI, setShowBlockUI] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showRePassword, setShowRePassword] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [defaultModal1, setdefaultModal1] = useState(false);
  // eslint-disable-next-line
  const [displayLocation, setDisplayLocation] = useState("");
  const [transitionStage, setTransistionStage] = useState("fadeFrom");
  const [valid, setValid] = useState({
    validChar: false,
    validLength: false,
  });
  const [value, setValue] = useState({
    repassword: "",
    password: "",
  });
  const [termsAndConditions, setTermsAndConditions] = useState({});
  const [hasVibeCfo, setHasVibeCfo] = useState(false);

  const length = new RegExp("(?=.{8,}$).*$");
  const char = new RegExp(
    "^(?=(.*?[A-Z]){1,})(?=(.*[a-z]){1,})(?=(.*?[0-9]){1,})(?=(.*?[!@#$%^&*]){1,}).*$"
  );

  let testCharacter = char.test(value.password);
  let testLength = length.test(value.password);

  const getFirmDetails = () => {
    let url = window.location.hostname.split(".");
    // console.log(url[0]);
    if (url[0] === "platform") {
      setFirmDetails({
        Code: "PLATFORM",
        Name: "Platform",
        ClientClausesConsents:
          "Etani Business Platform 14-Day Trial  (the App) \n1	Use of the App \n(a)	As part of our services, we may offer you the opportunity to sign-up to and use the App. The App allows the facility for us to build customised management reporting dashboards to you by streaming your live data sources from 50+ 3rd party programs (e.g. Xero, Quickbooks Online, Google Analytics, Salesforce, Stripe, Microsoft Excel) and therefore can be of considerable help to you and us in managing your taxation affairs. You can download the App from the Google Play Store or the Apple App Store. The App is owned and maintained by Etani Business Platform Pty Ltd A.C.N. 612 317 263 (Etani) and upon download, you will need to accept the terms and conditions of use for the App before using it. Etani can be contacted via its website. We licence the use of the App from Etani and we look forward to you enjoying all the great benefits and functions that the App can offer.\n(b)	When using the App, you may also connect to various third-party data sources (e.g. Xero, Quickbooks Online, Salesforce or Dropbox) (each a Third-Party Connector) and invite other people to have access to the App in respect of your account (e.g. one of your employees or your bookkeeper) (each, a Client Invitee). Your relationship with any Third-Party Connector is solely between you and the Third-Party Connector and may be governed by other terms of use or agreements that apply. The App functions as a mere portal between the Third-Party Connector, you and us. Likewise, it is your choice whether to grant a Client Invitee access to the App and your account. We, Etani and other third parties involved in providing and maintaining the App (each, a Third-Party Supplier) do not control or assume any liability associated with any access you grant to a Client Invitee or any data that you import from a Third-Party Connector and cannot be responsible for the quality, accuracy, nature, ownership, or any loss or damage in relation thereto. \n2	Personal Information, TFN Information and the App \n(a)	In order for you to sign-up to and use the App, we need to disclose certain personal information (including sensitive information) as defined in the Privacy Act 1988 (Cth) (together, Personal Information) and tax file number information (TFN Information) that we have collected about you to Etani and Third-Party Suppliers. The Third-Party Suppliers include Microsoft Azure who can be contacted via its respective website. \n(b)	By signing-up to and using the App, your Personal Information and TFN Information may also be: \n(i)	collected, held, used and disclosed between us, Etani, Third-Party Suppliers, Third-Party Connectors and Client Invitees; \n(ii)	disclosed to Etaniâ€™s employees who may be located overseas in the Philippines, and Google Analytics or other analytics providers who may store this information across a large multiple of countries (to which it is impracticable to name each one); and \n(iii)	disclosed to Third-Party Connectors and Client Invitees who may be located overseas; albeit, it is impracticable to name in which overseas countries they may be located (as this is dependent upon which, if any, Third-Party Connectors you choose to use or Client Invitees you choose to give access to). \n(c)	The collection of your TFN Information is authorised by taxation law, including the Tax Agent Services Act 2009 (Cth), Taxation Administration Act 1953 (Cth), Income Tax Assessment Act 1936 (Cth) and Income Tax Assessment Act 1997 (Cth). It is reasonably necessary and relevant for us, Etani and Third-Party Suppliers to collect, hold, use and disclose your Personal Information and TFN Information in this way in order to provide use of the App to you and to assist in managing your taxation affairs effectively. Declining to quote your TFN is not an offence and it is your choice whether to provide your Personal Information and TFN Information; however, if you don't provide any required Personal Information and TFN Information (or consent to their collection, holding, use and disclosure) it may not be possible for you to use all available functions of the App. \n(d)	Further information on the collection, holding, use and disclosure of your Personal Information in relation to the App can be found in Etaniâ€™s privacy policy, a copy of which is available by link on Etaniâ€™s website homepage, including how you may access your Personal Information, seek its correction, complain about a breach of the Australian Privacy Principles and how such complaint will be handled.	 \n3	Your Consent \nBy signing this engagement letter, you hereby: \n(a)	agree for us to offer you the opportunity to sign-up to and use the App on these terms and conditions; and \n(b)	consent to your Personal Information and TFN Information being collected, held, used and disclosed in the manner set out above and for the purpose of providing you access to, and use of, the App.",
      });
    } else {
      fetch(`/api/accountingFirm/getFirmDetailsPerSubDomain/${url[0]}`, {
        credentials: "include",
      })
        .then((res) => res.json())
        .then((data) => {
          if (data) {
            // console.log("getFirmDetailsPerSubDomain", data);
            setFirmDetails(data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const fetchAPIs = (hasVibeCfoUrl) => {
    fetch(`/api/termsAndConditions/getRecord?IntendedTo=${hasVibeCfoUrl ? 'VibeCfoAdvisors' : 'Advisors'}`)
      .then((response) => response.json())
      .then((data) => {
        // console.log(data)
        setTermsAndConditions(data)
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    if (routerLocation === displayLocation) setTransistionStage("fadeTo");
    const hostName = window.location.hostname;
    const hasVibeCfoUrl = hostName.includes('vibecfo');
    setHasVibeCfo(hasVibeCfoUrl)
    getFirmDetails();
    fetchAPIs(hasVibeCfoUrl)
  }, [routerLocation, displayLocation]);

  const handleChange = (e) => {
    e.preventDefault();

    const target = e.target;
    const name = target.name;
    const id = target.id;

    const newValue = Object.assign({}, value);

    newValue[name] = target.value;
    setValue(newValue);

    setError("");

    if (id === "Password") {
      setValid({
        validChar: false,
        validLength: false,
      });
      return setAlert(false);
    }
  };

  const handleSubmit = (e) => {
    // console.log('firm', firmDetails)
    e.preventDefault();

    if (!testLength && !testCharacter) {
      setAlert(true);
      return setValid({
        validChar: true,
        validLength: true,
      });
    }
    if (!testLength) {
      setAlert(true);
      return setValid({
        validLength: true,
      });
    }
    if (!testCharacter) {
      setAlert(true);
      return setValid({
        validChar: true,
      });
    }

    if (!testLength && !testCharacter && value.password !== value.repassword) {
      setError("Password did not match!");
      return setValid({
        validChar: true,
        validLength: true,
      });
    }

    if (value.password !== value.repassword)
      return setError("Password did not match!");

    setShowBlockUI(true);

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const token = urlParams.get("access_token");
    const bname = urlParams.get("bname");

    // console.log({ ...value, bname });

    fetch(`/api/user/changePassword?access_token=${token}`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify({ ...value, bname }),
    })
      .then((response) => {
        // console.log(response)
        return response.json();
      })
      .then((result) => {
        setTimeout(() => {
          // console.log(result)

          if (result && result.error) {
            // console.log('Error', result.error)

            setShowBlockUI(false);
            return warningAlert(result.error); //Edited by Joef: Fix error handling
          }
          if (result.success) {
            // fetch(`/api/customReport/subscribeToWorkspaceViaInvitedAdvisor`, {
            //   method: "POST",
            //   credentials: "include",
            //   body: JSON.stringify({
            //     business: result.business,
            //     user: result.user,
            //   }),
            // })
            //   .then((res) => res.json())
            //   .then((data) => {
            //     // console.log(data);
            //     // successAlert(data.message)
            //   });
            setUser(result);

            setValue({
              repassword: "",
              password: "",
            });
            setShowBlockUI(false);

            setTransistionStage("fadeTo");

            // console.log("result", result);

            setTimeout(() => {
              if (result.needSetPayment) {
                routerHistory.push(
                  // "/auth/create-password/password-succesfully-changed"
                  "/signup/payment-setup"
                );
              } else {
                routerHistory.push(
                  "/client"
                );
              }
              // window.location.href =
              // '/auth/create-password/password-succesfully-changed'
              setTransistionStage("fadeFrom");
            }, 250);
          }
        }, 1300);
      })
      .catch((Err) => {
        setShowBlockUI(true);

        setTimeout(() => {
          console.log(Err);
          setShowBlockUI(false);
          warningAlert(
            "Something went wrong, Please contact your system administrator."
          );
        }, 1000);
      });
  };

  const warningAlert = (res) => {
    setIsInvalid(
      <ReactBSAlert
        error
        title="Error"
        onConfirm={() => setIsInvalid(null)}
        confirmBtnBsStyle="danger"
        confirmBtnText="Ok"
        btnSize=""
      >
        {res || res.error || res.message}
      </ReactBSAlert>
    );
  };

  const errorStyle = (res) => {
    let val = "";

    res === true
      ? (val = value.password !== "" && testCharacter && testLength)
      : (val =
        value.password === value.repassword &&
        value.password !== "" &&
        testCharacter &&
        testLength);

    return alert !== false || error !== ""
      ? { border: "1px solid #fb6340" }
      : {
        border: val ? "1px solid #2dce89" : "1px solid transparent",
      };
  };

  const passwordLabels = () => {
    if (value.password !== "" && testCharacter && testLength) return null;
    return (
      <div
        className="d-flex flex-column text-sm"
        style={{ transition: "ease-in-out .2s" }}
      >
        <PasswordLabel
          label="Password must contain uppercase, lowercase, numeric, and special characters"
          validType={valid.validChar === true}
          testType={testCharacter}
          password={value.password}
          repassword={value.repassword}
        />
        <PasswordLabel
          label="Password must be at least 8 characters long"
          validType={valid.validLength === true}
          testType={testLength}
          password={value.password}
          repassword={value.repassword}
        />
      </div>
    );
  };

  const openTerms = () => {
    setdefaultModal1(true);
  };

  const closeMainModal = () => {
    setdefaultModal1(false);
  };

  const acceptTerms = () => {
    setShowBlockUI(true);

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const token = urlParams.get("access_token");
    const bname = urlParams.get("bname");



    fetch(`/api/accountant/getRecordForTandC?token=${token}${bname ? `&bname=${bname}` : ""}`)
      .then((response) => response.json())
      .then((result) => {
        // console.log(result);
        if (result && !result.error) {
          setShowBlockUI(false)
          setTermsAccepted(true);
          setdefaultModal1(false);
          setTransistionStage("fadeTo");
          setTimeout(() => {
            routerHistory.push(
              `/auth/create-password/setup-new-password?access_token=${token}${bname ? `&bname=${bname}` : ""}`
            );
            setTransistionStage("fadeFrom");
          }, 400);
        }
        if (result.error) {
          warningAlert(result.error)
          setShowBlockUI(false)
        }
      })
      .catch((err) => {
        setShowBlockUI(false)
        console.log(err);
      });
  };

  return (
    <>
      {isInvalid}
      {showBlockUI ? <BlockUI /> : null}
      <div
        style={{
          width: "100vw",
          height: "100vh",
          overflow: "hidden",
          position: "relative",
          backgroundColor: "#fff",
          display: "grid",
        }}
      >
        {/* <img
          className="fadeIn"
          src={require('assets/img/box.svg').default}
          alt="box"
          style={{
            position: 'absolute',
            width: '110%',
            height: '100%',
            bottom: -250,
            top: 0,
            opacity: 0.8,
          }}
        /> */}
        <Container className="align-items-center " style={{ display: "grid" }}>
          <Row className="justify-content-center">
            <Col
              lg="6"
              md="8"
              sm="12"
              xs="12"
              className={`${transitionStage} mt-2 px-0 px-lg-3`}
            >
              <Switch className="pl-0">
                <Route
                  path="/auth/create-password"
                  exact
                  render={() => (
                    <>
                      <Modal
                        className="modal-dialog-top"
                        isOpen={defaultModal1}
                        toggle={() => closeMainModal()}
                        size="lg"
                        backdrop="static"
                        scrollable={true}
                        centered={true}
                      >
                        <div
                          className="modal-header"
                          style={{ paddingBottom: "0px" }}
                        >
                          <button
                            aria-label="Close"
                            className="close"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => closeMainModal()}
                          >
                            <span aria-hidden={true}>×</span>
                          </button>
                        </div>
                        <div
                          className="modal-body"
                          style={{ paddingTop: "0px", textAlign: "left" }}
                        >
                          <h1>
                            <strong>Terms and Conditions</strong>
                          </h1>
                          {
                            termsAndConditions ? <ReactQuill
                              value={termsAndConditions.Details}
                              readOnly={true}
                              theme={"bubble"}
                            /> : null
                          }
                          {/* <h1>{firmDetails?.Name} (The App)</h1>
                          {firmDetails &&
                            !firmDetails.ClientClausesConsents.includes("<p>") ? (
                            <div className="modal-terms-blk">
                              <p>
                                <strong>1 Use of the App</strong>
                              </p>
                              <p className="ql-indent-1">
                                (a)&nbsp;&nbsp;&nbsp;As part of our services, we
                                may offer you the opportunity to sign-up to and
                                use the App. The App allows the facility for us
                                to build customised management reporting
                                dashboards to you by streaming your live data
                                sources from 100+ 3rd party programs (e.g. Xero,
                                Quickbooks Online, Google Analytics, Salesforce,
                                Stripe, Microsoft Excel) and therefore can be of
                                considerable help to you and us in managing your
                                taxation affairs. You can download the App from
                                the Google Play Store or the Apple App Store.
                                The App is owned and maintained by One Place
                                Business Platform Pty Ltd A.C.N. 621 278 180
                                (Etani) and upon download, you will need to
                                accept the terms and conditions of use for the
                                App before using it. Etani can be contacted via
                                its website. We licence the use of the App from
                                Etani and we look forward to you enjoying all
                                the great benefits and functions that the App
                                can offer.
                              </p>
                              <p className="ql-indent-1">
                                (b)&nbsp;&nbsp;&nbsp;When using the App, you may
                                also connect to various third-party data sources
                                (e.g. Xero, Quickbooks Online, Salesforce or
                                Dropbox) (each a Third-Party Connector) and
                                invite other people to have access to the App in
                                respect of your account (e.g. one of your
                                employees or your bookkeeper) (each, a Client
                                Invitee). Your relationship with any Third-Party
                                Connector is solely between you and the
                                Third-Party Connector and may be governed by
                                other terms of use or agreements that apply. The
                                App functions as a mere portal between the
                                Third-Party Connector, you and us. Likewise, it
                                is your choice whether to grant a Client Invitee
                                access to the App and your account. We, Etani
                                and other third parties involved in providing
                                and maintaining the App (each, a Third-Party
                                Supplier) do not control or assume any liability
                                associated with any access you grant to a Client
                                Invitee or any data that you import from a
                                Third-Party Connector and cannot be responsible
                                for the quality, accuracy, nature, ownership, or
                                any loss or damage in relation thereto.
                              </p>
                              <p>
                                <strong>
                                  2&nbsp;&nbsp;&nbsp;Personal Information, TFN
                                  Information and the App
                                </strong>
                              </p>
                              <p className="ql-indent-1">
                                (a)&nbsp;&nbsp;&nbsp;In order for you to sign-up
                                to and use the App, we need to disclose certain
                                personal information (including sensitive
                                information) as defined in the Privacy Act 1988
                                (Cth) (together, Personal Information) and tax
                                file number information (TFN Information) that
                                we have collected about you to Etani and
                                Third-Party Suppliers. The Third-Party Suppliers
                                include Microsoft Azure who can be contacted via
                                its respective website.
                              </p>
                              <p className="ql-indent-1">
                                (b)&nbsp;&nbsp;&nbsp;By signing-up to and using
                                the App, your Personal Information and TFN
                                Information may also be:
                              </p>
                              <p className="ql-indent-3">
                                (i)&nbsp;&nbsp;&nbsp;collected, held, used and
                                disclosed between us, Etani, Third-Party
                                Suppliers, Third-Party Connectors and Client
                                Invitees;
                              </p>
                              <p className="ql-indent-3">
                                (ii)&nbsp;&nbsp;&nbsp;disclosed to Etani’s
                                employees who may be located overseas in the
                                Philippines, and Google Analytics or other
                                analytics providers who may store this
                                information across a large multiple of countries
                                (to which it is impracticable to name each one);
                                and
                              </p>
                              <p className="ql-indent-3">
                                (iii)&nbsp;&nbsp;&nbsp;disclosed to Third-Party
                                Connectors and Client Invitees who may be
                                located overseas; albeit, it is impracticable to
                                name in which overseas countries they may be
                                located (as this is dependent upon which, if
                                any, Third-Party Connectors you choose to use or
                                Client Invitees you choose to give access to).
                              </p>
                              <p className="ql-indent-1">
                                (c)&nbsp;&nbsp;&nbsp;The collection of your TFN
                                Information is authorised by taxation law,
                                including the Tax Agent Services Act 2009 (Cth),
                                Taxation Administration Act 1953 (Cth), Income
                                Tax Assessment Act 1936 (Cth) and Income Tax
                                Assessment Act 1997 (Cth). It is reasonably
                                necessary and relevant for us, Etani and
                                Third-Party Suppliers to collect, hold, use and
                                disclose your Personal Information and TFN
                                Information in this way in order to provide use
                                of the App to you and to assist in managing your
                                taxation affairs effectively. Declining to quote
                                your TFN is not an offence and it is your choice
                                whether to provide your Personal Information and
                                TFN Information; however, if you don't provide
                                any required Personal Information and TFN
                                Information (or consent to their collection,
                                holding, use and disclosure) it may not be
                                possible for you to use all available functions
                                of the App.
                              </p>
                              <p className="ql-indent-1">
                                (d)&nbsp;&nbsp;&nbsp;Further information on the
                                collection, holding, use and disclosure of your
                                Personal Information in relation to the App can
                                be found in Etani’s privacy policy, a copy of
                                which is available by link on Etani’s website
                                homepage, including how you may access your
                                Personal Information, seek its correction,
                                complain about a breach of the Australian
                                Privacy Principles and how such complaint will
                                be handled.&nbsp;&nbsp;&nbsp;&nbsp;
                              </p>
                              <p>
                                <strong>3&nbsp;&nbsp;&nbsp;Your Consent</strong>
                              </p>
                              <p>
                                By signing this engagement letter, you hereby:
                              </p>
                              <p className="ql-indent-1">
                                (a)&nbsp;&nbsp;&nbsp;agree for us to offer you
                                the opportunity to sign-up to and use the App on
                                these terms and conditions; and&nbsp;
                              </p>
                              <p className="ql-indent-1">
                                (b)&nbsp;&nbsp;&nbsp;consent to your Personal
                                Information and TFN Information being collected,
                                held, used and disclosed in the manner set out
                                above and for the purpose of providing you
                                access to, and use of, the App.
                              </p>
                            </div>
                          ) : (
                            <div
                              className="modal-terms-blk"
                              dangerouslySetInnerHTML={{
                                __html: firmDetails?.ClientClausesConsents,
                              }}
                            ></div>
                          )} */}
                        </div>
                        <div
                          className="modal-footer"
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <Button
                            style={{ backgroundColor: "#272A65", borderColor: "#272A65" }}
                            className="mt-2"
                            color="primary"
                            type="button"
                            onClick={(e) => {
                              acceptTerms();
                            }}
                          >
                            Accept and Continue
                          </Button>
                        </div>
                      </Modal>
                      <Card className=" justify-content-center  p-3 p-lg-4 shadow-none bg-transparent">
                        <CardImg
                          alt="Login"
                          src={"/api/accountingFirm/getThemeLogo"}
                          style={{ width: "150px", margin: "1rem auto" }}
                          className=" justify-content-center text-center rounded "
                          top
                        />
                        <CardHeader className="bg-transparent mb-2 border-top px-0">
                          {/* ------------ unable to show dynamic name of firms ----------*/}

                          <h1 className="h1 text-center text-normal" style={{ color: "#272A65" }}>
                            Welcome to the{" "}
                            {`${firmDetails?.Code === "PLATFORM"
                              ? "Etani"
                              : firmDetails?.Name
                              }`}{" "}
                            Business Platform
                          </h1>

                          {/* ------------------*/}

                          <p className="mt-4 text-center">
                            Before you can proceed to set up a unique password
                            for your new account, please read and accept the{" "}
                            <strong className="" style={{ color: "#272A65" }}>
                              Terms and Conditions
                            </strong>
                            .
                          </p>
                        </CardHeader>
                        <CardBody className="p-2">
                          <div className="text-center">
                            <Button
                              style={{ backgroundColor: "#272A65", borderColor: "#272A65" }}
                              className="mt-2"
                              color="primary"
                              type="button"
                              onClick={(e) => {
                                openTerms();
                              }}
                            >
                              View Terms
                            </Button>
                            {termsAccepted ? (
                              <Button
                                style={{ backgroundColor: "#272A65", borderColor: "#272A65" }}
                                className="mt-2"
                                color="primary"
                                type="button"
                                onClick={(e) => {
                                  setTransistionStage("fadeTo");

                                  setTimeout(() => {
                                    routerHistory.push(
                                      "/auth/create-password/setup-new-password"
                                    );
                                    setTransistionStage("fadeFrom");
                                  }, 400);
                                }}
                                disabled={termsAccepted ? false : true}
                              >
                                Continue
                              </Button>
                            ) : null}
                          </div>
                        </CardBody>
                      </Card>
                    </>
                  )}
                />
                <Route
                  path="/auth/create-password/setup-new-password"
                  render={() => (
                    <Card className=" bg-transparent shadow-none p-3 mb-0 py-3 px-lg-5 mx-2 ">
                      <CardImg
                        alt="Login"
                        src={"/api/accountingFirm/getThemeLogo"}
                        style={{ width: "150px" }}
                        className=" justify-content-center text-center rounded mx-auto"
                        top
                      />
                      <CardHeader className="px-0 pb-0 bg-transparent">
                        <h1 className="h2 text-center text-normal">
                          Create new password
                        </h1>
                      </CardHeader>
                      <CardBody className="pt-2 p-0">
                        <Form role="form" onSubmit={handleSubmit}>
                          <CustomInputFields
                            type={!showPassword ? "password" : "text"}
                            onClick={() => setShowPassword(!showPassword)}
                            placeholder="Enter your new password here"
                            className={`${value.password === value.repassword &&
                              value.password !== "" &&
                              testCharacter &&
                              testLength
                              ? "fas fa-check text-success "
                              : "fas fa-unlock-alt"
                              }`}
                            htmlFor="Password"
                            label="Password"
                            id="Password"
                            name="password"
                            value={value.password}
                            onChange={handleChange}
                            showPassword={showPassword}
                            showPasswordIcon={true}
                            alert={alert}
                            error={error}
                            // required={true}
                            style={errorStyle(true)}
                          />

                          <CustomInputFields
                            onClick={() => setShowRePassword(!showRePassword)}
                            type={!showRePassword ? "password" : "text"}
                            placeholder="Re-enter your password here"
                            showPassword={showRePassword}
                            alert={alert}
                            error={error}
                            className={`${value.password === value.repassword &&
                              value.password !== "" &&
                              testCharacter &&
                              testLength
                              ? "fas fa-check text-success "
                              : "fas fa-lock"
                              }`}
                            label="Confirm Password"
                            value={value.repassword}
                            showPasswordIcon={true}
                            htmlFor="RePassword"
                            id="RePassword"
                            name="repassword"
                            onChange={handleChange}
                            // required={true}
                            style={errorStyle(false)}
                          />

                          {error !== "" ? (
                            <Row className=" text-sm">
                              <Col
                                xs="1"
                                style={{
                                  fontSize: "12px ",
                                  marginTop: "5px",
                                }}
                              >
                                <i className="text-warning mx-1 fas fa-times " />
                              </Col>
                              <Col lg="10" xs="10">
                                <span
                                  className="text-warning font-weight-600"
                                  style={{ fontSize: "12px" }}
                                >
                                  {error}
                                </span>
                              </Col>
                            </Row>
                          ) : null}

                          {passwordLabels()}
                          <div className="text-center mt-4">
                            <Button
                              style={{ backgroundColor: "#272A65", borderColor: "#272A65", color: "#fff" }}
                              className="mt-3"
                              type="submit"
                              block
                              disabled={
                                value.password === "" || value.repassword === ""
                                  ? true
                                  : false
                              }
                            >
                              Submit
                            </Button>
                          </div>
                        </Form>
                      </CardBody>
                    </Card>
                  )}
                />
                <Route
                  path="/auth/create-password/password-succesfully-changed"
                  render={() => (
                    <Card
                      className="bg-transparent p-sm-2 py-3 p-lg-4 mx-3 shadow-none"
                      style={{ overflow: "hidden" }}
                    >
                      <CardImg
                        alt="Login"
                        src={
                          require("../../../../assets/img/success-36.svg")
                            .default
                        }
                        style={{ width: "80px", margin: "0 auto" }}
                        className="spin justify-content-center text-center rounded my-3"
                        top
                      />
                      <CardHeader className="bg-transparent text-center border-0 py-2">
                        <h1 className="h1" style={{ color: "#272A65" }}>
                          Password setup completed!
                        </h1>
                      </CardHeader>
                      <CardHeader className="bg-transparent text-center border-0 px-xl-4 px-2  mt--2 text-sm-sm">
                        You have successfully setup your account password, click
                        <span
                          className="text-primary ml-2 text-underline"
                          style={{ cursor: "pointer" }}
                          onClick={() => (window.location.href = "/auth/login")}
                        >
                          here
                        </span>{" "}
                        to login on your account in the CMS.
                      </CardHeader>
                    </Card>
                  )}
                />
              </Switch>
              {window.location.pathname !==
                ("/auth/create-password/setup-new-password" &&
                  "/auth/create-password/password-succesfully-changed") ? (
                <Row className="w-xs-100 mx-auto mt-3 px-5 spin">
                  <AdminFooter hasVibeCfo={hasVibeCfo} />
                </Row>
              ) : null}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default AcceptInvitaion;
